"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTime = void 0;

var pad = function pad(input) {
  var result = input.toString();
  return result.length !== 2 ? "0".concat(result) : result;
};

var formatTime = function formatTime(timeInSeconds) {
  if (!timeInSeconds) return null;
  var intTimeInSeconds = parseInt(timeInSeconds, 10);
  if (isNaN(intTimeInSeconds)) return null;
  var minutes = intTimeInSeconds / 60;
  var hours = minutes / 60;

  if (hours > 1) {
    return "".concat(pad(Math.floor(hours)), ":").concat(pad(Math.floor(minutes - 60 * Math.floor(hours))), ":").concat(pad(Math.floor(intTimeInSeconds - 60 * Math.floor(minutes))));
  } else {
    return "".concat(pad(Math.floor(minutes)), ":").concat(pad(Math.floor(intTimeInSeconds - 60 * Math.floor(minutes))));
  }
};

exports.formatTime = formatTime;